import { Injectable } from '@angular/core';
import { BaseApiService } from '../../shared/base-service/base-api.service';

@Injectable()
export class CustomerListService extends BaseApiService {
    public getCustomersList() {
        return this.get('Foundation/BusinessTransaction/Lookups/');
    }
}
